// native <dialog> helpers.
import { $$, play } from './core.ts';

// ---------------- small parts ----------------
export function initDialogs(): void {
  document.addEventListener('click', e => {
    const open = (e.target as Element).closest<HTMLElement>('[data-ds-dialog-open]');
    if (open) {
      const d = document.getElementById(open.dataset.dsDialogOpen!) as HTMLDialogElement | null;
      if (d?.showModal) {
        d.showModal();
        $$('.ds-ico', d).forEach(play);
      }
      return;
    }
    const close = (e.target as Element).closest('[data-ds-dialog-close]');
    if (close) {
      close.closest('dialog')?.close();
      return;
    }
    if (
      (e.target as Element).tagName === 'DIALOG' &&
      ((e.target as Element).classList.contains('ds-dialog') || (e.target as Element).classList.contains('ds-modal'))
    ) {
      (e.target as HTMLDialogElement).close();
      return;
    } // a click on the backdrop
    if ((e.target as Element).closest('[data-ds-print]')) window.print();
  });
}
